import { render } from "./SectionItems.vue?vue&type=template&id=f8d2c662&scoped=true"
import script from "./SectionItems.vue?vue&type=script&lang=js"
export * from "./SectionItems.vue?vue&type=script&lang=js"

import "./SectionItems.vue?vue&type=style&index=0&id=f8d2c662&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8d2c662"]])

export default __exports__